import React from 'react';

export default function ErrorScreen() {
    return (
        <div className="flex flex-col justify-center items-center min-h-screen p-4 box-border text-center">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-16 w-16 text-gray-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13 16h-1v-4h-1m1 4h1v4h-1m0 0v-4m-5-6h14M7 12l5 5L22 7"
                />
            </svg>
            <h3 className="text-xl font-semibold mt-4 mb-2">
                Sorry! Something went wrong!
            </h3>
        </div>
    );
}
